import { assessmentQuestionsNl } from "./data/assessmentData.nl";
import {
  CROSS_P2_NL,
  CROSS_P3_EN_AVANCE_NL,
  CROSS_P3_EN_RETRAIT_NL,
  CROSS_P3_UNIFORME_NL,
  PILLAR_FEEDBACKS_NL,
} from "./data/feedbackData.nl";
import type { LocaleStrings } from "./utils";

const nl: LocaleStrings = {
  ui: {
    "nav.previous": "Vorige",
    "nav.next": "Volgende",
    "nav.results": "Resultaten",
    "groups.1": "Strategie & Aansturing",
    "groups.2": "Merk & Beleving",
    "groups.3": "Content & Zichtbaarheid",
    "groups.4": "AI & Tools",
    "welcome.title": "Hoe ver staat uw organisatie op marketingvlak?",
    "welcome.cta": "Start hier",
    "welcome.tagline": "Directe resultaten · Geheel vrijblijvend",
    "welcome.intro.bold": "Inzichten op maat voor uw organisatie.",
    "welcome.intro.p1":
      "B2B-marketing staat op een kantelpunt. AI herschrijft de spelregels voor marketingteams. Het versterkt wat sterk is... maar vergroot ook wat zwak is.",
    "welcome.intro.p2":
      "Wat gisteren werkte, werkt vandaag niet meer. Wat morgen werkt, is nog onduidelijk.",
    "welcome.intro.p3":
      "In 4 thema's — strategie, merk, content en AI — krijgt u een helder beeld van uw marketing en de prioriteit die er écht toe doet.",
    "welcome.summary.title": "Samenvatting",
    "welcome.summary.li1": "{n} vragen",
    "welcome.summary.li2": "4 thema's: strategie, merk, content en AI",
    "welcome.summary.li3": "Directe resultaten · Geen verplichtingen",
    "emailCapture.emailLabel":
      "Laat uw e-mailadres achter om uw voortgang op te slaan, kunnen stoppen en later verder te gaan wanneer u wilt, en uw resultaten aan het einde te ontvangen.",
    "emailCapture.emailPlaceholder": "Uw professioneel e-mailadres",
    "emailCapture.emailPrivacy":
      "Uw e-mail blijft bij ons. We geven hem aan niemand door. Uw e-mailadres blijft strikt bij Be-one.",
    "emailCapture.errorEmpty": "Vul uw e-mailadres in",
    "emailCapture.errorInvalid": "Vul een geldig e-mailadres in",
    "emailCapture.errorEmailForLink":
      "Met uw e-mailadres sturen we u de link zodat u op elk moment verder kunt gaan.",
    "emailCapture.errorCompany": "Vul de naam van uw bedrijf in",
    "emailCapture.company.title": "We verifiëren uw bedrijf",
    "emailCapture.company.withSuggestion":
      "We hebben dit bedrijf geïdentificeerd op basis van uw e-mailadres. Kunt u de naam bevestigen of corrigeren?",
    "emailCapture.company.noSuggestion":
      "We hebben uw bedrijf niet automatisch gevonden. Kunt u het hieronder invullen?",
    "emailCapture.company.placeholder": "Naam van uw bedrijf",
    "emailCapture.continue": "Doorgaan",
    "emailCapture.pauseLater.hint":
      "Heeft u nu niet voldoende tijd? Vul uw e-mailadres hierboven in en u ontvangt een link om precies verder te gaan waar u gebleven bent.",
    "emailCapture.pauseLater.button": "Later hervatten",
    "emailCapture.previous": "Vorige",
    "emailCapture.themeTitle": "Thema 1:",
    "companyCapture.title": "Vóór uw resultaten",
    "companyCapture.subtitle":
      "Voordat we uw resultaten tonen, hebben we uw bedrijfsnaam nodig, zo kunnen we de analyse écht op maat maken voor uw organisatie.",
    "companyCapture.withSuggestion":
      "We hebben dit bedrijf geïdentificeerd op basis van uw e-mailadres. U kunt het bevestigen of corrigeren.",
    "companyCapture.noSuggestion":
      "We hebben uw bedrijf niet automatisch gevonden. Kunt u het hieronder invullen?",
    "companyCapture.placeholder": "Naam van uw bedrijf",
    "companyCapture.errorEmpty": "Vul de naam van uw bedrijf in",
    "companyCapture.confirm": "Bevestigen en mijn resultaten bekijken",
    "paused.title": "Uw voortgang is opgeslagen.",
    "paused.body":
      "U kunt op elk moment hervatten via deze link, uw voortgang is opgeslagen in uw browser.",
    "paused.copy": "Kopiëren",
    "paused.copied": "Gekopieerd!",
    "paused.emailReminder":
      "U ontvangt ook een herinneringsmail met de juiste link.",
    "paused.continueNow": "Ik wil nu verder",
    "loading.title": "We analyseren uw antwoorden...",
    "loading.msg1":
      "Uw antwoorden worden getoetst aan twintig jaar B2B-marketingervaring van Be-one.",
    "loading.msg2": "Analyse loopt (echt denkwerk, geen copy-paste).",
    "loading.msg3":
      "Onze AI agent kauwt op uw antwoorden. Letterlijk niet, figuurlijk wel.",
    "loading.msg4":
      "We leggen uw antwoorden naast elkaar. Waar het wringt, wordt het interessant.",
    "loading.msg5":
      "Kruisanalyse loopt — de eerste interessante vondsten zijn binnen.",
    "loading.msg6":
      "Onze AI-agent schrijft uw analyse. Wij controleren of hij geen onzin uitkraamt.",
    "loading.msg7":
      "Uw resultaten houden we achter slot en grendel. Jammer voor uw concurrenten.",
    "loading.msg8":
      "We pennen uw aanbevelingen neer. De eerste komt misschien hard aan.",
    "loading.msg9":
      "Bijna klaar, we schaven aan de formulering zodat ze nuttig en helder is.",
    "loading.msg10": "Slim geïnvesteerde tijd. U werkt aan uw strategie.",
    "loading.msg11":
      "Goed bestede tijd. Op het volgende directiecomité bent u de enige met antwoorden.",
    "themeComplete.title": "Thema {num}:",
    "themeComplete.continue": "Doorgaan naar de volgende thema {next}",
    "themeComplete.previous": "Vorige",
    "radar.progress": "Thema {num}/4",
    "radar.ariaLabel": "Radargrafiek: uw marketingscores",
    "radar.svgTitle": "Radargrafiek: uw marketingscores",
    "radar.svgDesc":
      "Radardiagram van de vier pijlers van B2B-marketing, scores op een schaal van 4.",
    "results.title": "Uw resultaten",
    "results.subtitle": "Uit uw antwoorden blijkt het volgende.",
    "results.situation": "Situatie",
    "results.priority": "Uw prioriteit",
    "results.why": "Waarom deze prioriteit",
    "results.noAnalysis.line1":
      "De gepersonaliseerde analyse vereist een internetverbinding.",
    "results.noAnalysis.line2":
      'Maak opnieuw verbinding en klik op "Opnieuw proberen" om deze te ontvangen.',
    "results.retry": "Opnieuw proberen",
    "results.emailConfirm":
      "📩 U ontvangt uw resultaten ook per e-mail, om ze rustig na te lezen wanneer het u uitkomt.",
    "results.downloadPdf": "Pdf downloaden… wees uw concurrenten voor.",
    "results.pdfFilename": "diagnose-marketing-b2b-be-one.pdf",
    "results.cta": "Plan een gratis strategiegesprek",
    "results.ctaHref": "https://be-one.net/nl/calendly",
    "results.ctaSubtext":
      "Uw prioriteit verdient beter dan een goede intentie. 30 minuten, één strategische blik, één actieplan. Plan uw afspraak in!",
    "results.restart": "Nieuwe evaluatie starten",
  },
  questions: assessmentQuestionsNl,
  feedback: {
    pillarFeedbacks: PILLAR_FEEDBACKS_NL,
    crossP2: CROSS_P2_NL,
    crossP3Uniforme: CROSS_P3_UNIFORME_NL,
    crossP3EnRetrait: CROSS_P3_EN_RETRAIT_NL,
    crossP3EnAvance: CROSS_P3_EN_AVANCE_NL,
  },
  radarAxisLabels: [
    "Strategie\n& Aansturing",
    "Merk\n& Beleving",
    "Content\n& Zichtbaarheid",
    "AI\n& Tools",
  ],
};

export default nl;
